<template>
  <div class="text-left">
    <v-row>
      <v-col cols="12">
        <h3 class="mt-15 mb-0">
          {{ $t("title.bookAndChapterData") }}
        </h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <h5>
          {{ $t("form.title") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.bookandchapter.title"
              :label="$t('form.title')"
              outlined
              :readonly="disabledForm"
              :rules="rules.char_max_250"
              :counter="250"
              @change="$emit('handle-change', 'bookandchapter', 'title')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.type") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.bookandchapter.type"
              :label="$t('form.bookandchapter.type')"
              :rules="rules.fieldRequired"
              :items="bookAndChapterTypes"
              item-value="value"
              item-text="text"
              :readonly="disabledForm"
              @change="$emit('handle-change', 'bookandchapter', 'type')"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <h5>{{ $t("editorial") }}</h5>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.bookandchapter.editorial"
              :label="$t('editorial')"
              :rules="rules.fieldRequired"
              :items="editorials"
              item-value="id"
              item-text="name"
              :readonly="disabledForm"
              @change="$emit('handle-change', 'bookandchapter', 'editorial')"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.num_pages") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.bookandchapter.num_pages"
              :label="$t('form.bookandchapter.num_pages')"
              required
              outlined
              type="number"
              :readonly="disabledForm"
              @change="$emit('handle-change', 'bookandchapter', 'num_pages')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.publication_date") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-menu
              v-model="menu_publication_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="disabledForm"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  v-model="publication.bookandchapter.publication_date"
                  :label="$t('form.bookandchapter.publication_date')"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="publication.bookandchapter.publication_date"
                @input="menu_publication_date = false"
                :readonly="disabledForm"
                @change="
                  $emit('handle-change', 'bookandchapter', 'publication_date')
                "
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <h5>{{ $t("form.editors") }}</h5>
    <SelectPeopleList
      :items-selected="book_editors"
      :disabled-form="disabledForm"
      @change="$emit('handle-change', 'bookandchapter', 'editors')"
    />
    <h5>
      {{ $t("form.bookandchapter.editors_text") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.editors_text"
          :label="$t('form.bookandchapter.editors_text')"
          outlined
          :rules="rules.char_max_300"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'bookandchapter', 'editors_text')"
        />
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.bookandchapter.book_location") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.chapter"
          :label="$t('form.bookandchapter.chapter')"
          required
          outlined
          :readonly="disabledForm"
          @change="$emit('handle-change', 'bookandchapter', 'book_location')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_number"
          :label="$t('form.bookandchapter.pageNumber')"
          required
          outlined
          :readonly="disabledForm"
          @change="$emit('handle-change', 'bookandchapter', 'book_location')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_start"
          :label="$t('form.bookandchapter.pageStart')"
          @change="$emit('handle-change', 'bookandchapter', 'book_location')"
          required
          outlined
          :readonly="disabledForm"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_end"
          :label="$t('form.bookandchapter.pageEnd')"
          @change="$emit('handle-change', 'bookandchapter', 'book_location')"
          required
          outlined
          :readonly="disabledForm"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validationRules from "../../../mixins/validationRules";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  components: { SelectPeopleList },
  mixins: [validationRules, publication_model],
  name: "ModifyArticle",
  props: {
    book_editors: Array,
    disabledForm: Boolean,
    publication: Object
  },
  data: () => ({
    menu_publication_date: false
  }),

  created() {
    this.getEditorials();
    this.getBookAndChapterTypes();
  }
};
</script>

<style scoped></style>
